import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/services/globales.service';
import { IonIcon, IonSpinner, IonPopover, IonContent } from '@ionic/angular/standalone'

@Component({
  selector: 'app-appstatus',
  templateUrl: './appstatus.component.html',
  styleUrls: ['./appstatus.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonIcon,
    IonSpinner,
    IonPopover,
    IonContent
  ]
})
export class AppstatusComponent {

  //#region Constructor

  constructor(
    public globales: GlobalesService
  ) { }

  //#endregion

  //#region Recargar aplicación

  public reload(): void {
    location.reload()
  }

  //#endregion

}
